import React from "react";

export default function FullPageModal({ isOpen, onClose, children }) {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] bg-black/60 flex justify-center items-center"
      onClick={(e) => e.stopPropagation()}   // ป้องกันไม่ลงไป modal ชั้นล่าง
    >

      <div
        className="bg-white w-[90%] h-[90%] rounded-xl shadow-xl overflow-hidden flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >

        
        {/* Header */}
        <div className="p-3 bg-[#E13F57] text-white flex justify-between items-center">
          <h3 className="text-lg font-bold">ข้อมูลลูกค้า</h3>
          <button onClick={onClose} className="text-xl px-2">×</button>
        </div>

        {/* Body */}
        <div className="flex-1 overflow-auto p-0">
          {children}
        </div>
      </div>
    </div>
  );
}
